import { DxPopupModule, DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule, DxButtonModule, DxCheckBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTemplatesCreateProjectFromTemplateComponent } from './project-templates-create-project-from-template.component';



@NgModule({
  declarations: [ProjectTemplatesCreateProjectFromTemplateComponent],
	exports: [ProjectTemplatesCreateProjectFromTemplateComponent],
  imports: [
    CommonModule,
		DxPopupModule,
		DxTextBoxModule,
		DxDateBoxModule,
		DxSelectBoxModule,
		DxButtonModule,
		DxCheckBoxModule,
  ]
})
export class ProjectTemplatesCreateProjectFromTemplateModule { }
